import { Tooltip, Typography } from "@mui/material"
import { ReactElement } from "react"

type AppTooltipProps = {
    children: ReactElement
    title: string
    open?: boolean
    visible?: boolean
    onOpen?: () => void
    onClose?: () => void
}

/**
 * Re-usable tooltip component for use across application. This should be used
 * for all tooltips across the codebase.
 *
 * @example
 * <AppTooltip title="tooltip name">
 *      <Content />
 *  <AppTooltip>
 */

const AppTooltip = ({
    title,
    children,
    open,
    onOpen,
    onClose,
    visible = true,
}: AppTooltipProps): ReactElement =>
    visible ? (
        <Tooltip
            title={
                title && (
                    <Typography variant="body1" fontWeight={400}>
                        {title}
                    </Typography>
                )
            }
            open={open}
            onOpen={onOpen}
            onClose={onClose}
            disableInteractive
            followCursor
            placement="top"
        >
            {children}
        </Tooltip>
    ) : (
        children
    )

AppTooltip.defaultProps = {
    open: undefined,
    onOpen: undefined,
    onClose: undefined,
    visible: true,
}

export default AppTooltip
